import { render, staticRenderFns } from "./margin-isconsigned.vue?vue&type=template&id=293a79e5&scoped=true&"
import script from "./margin-isconsigned.vue?vue&type=script&lang=js&"
export * from "./margin-isconsigned.vue?vue&type=script&lang=js&"
import style0 from "./margin-isconsigned.vue?vue&type=style&index=0&id=293a79e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293a79e5",
  null
  
)

export default component.exports